import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/Button';
import { Menu, X, Grid } from 'lucide-react';
import { cn } from '../../lib/utils';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/t3J9pG9VM9s2YNfBdSCinK/Logo_Kementerian_Lingkungan_Hidup_-_Badan_Pengendalian_Lingkungan_Hidup_(2024).png';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  const navItems = [{
    name: 'Beranda',
    path: '/'
  }, {
    name: 'Bank Konten',
    path: '/bank-konten'
  }, {
    name: 'Series Tematik',
    path: '/series'
  }, {
    name: 'Event & Aksi',
    path: '/event'
  }, {
    name: 'Komunitas',
    path: '/komunitas'
  }, {
    name: 'Partisipasi',
    path: '/partisipasi'
  }];
  return <header className="sticky top-0 z-50 w-full border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60 shadow-sm" data-id="element-200">
      <div className="container mx-auto px-4 md:px-6 h-16 flex items-center justify-between" data-id="element-201">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 group" data-id="element-202">
          <img src={LOGO_URL} alt="Logo Kementerian Lingkungan Hidup" className="h-10 w-10 object-contain" data-id="element-203" />
          <div className="flex flex-col" data-id="element-204">
            <span className="font-bold text-lg leading-none text-gray-900" data-id="element-205">
              Indonesia ASRI Hub
            </span>
            <span className="text-[10px] font-medium text-gray-500 tracking-wider" data-id="element-206">
              PLATFORM KIE NASIONAL
            </span>
          </div>
        </Link>

        {/* Desktop Nav - Fixed breakpoint to lg */}
        <nav className="hidden lg:flex items-center gap-6" data-id="element-207">
          {navItems.map(item => <Link key={item.path} to={item.path} className={cn('text-sm font-medium transition-colors hover:text-primary-600', isActive(item.path) ? 'text-primary-600 font-semibold' : 'text-gray-600')} data-id="element-208">
              {item.name}
            </Link>)}
        </nav>

        {/* Desktop CTA - Fixed breakpoint to lg */}
        <div className="hidden lg:flex items-center gap-4" data-id="element-209">
          <Link to="/portal" className="text-sm font-medium text-gray-500 hover:text-primary-600 flex items-center gap-1.5" data-id="element-210">
            <Grid className="h-4 w-4" data-id="element-211" />
            Pilih Portal
          </Link>
          <Link to="/lapor-isu" data-id="element-212">
            <Button className="bg-primary-600 hover:bg-primary-700 text-white shadow-sm" data-id="element-213">
              Lapor Isu
            </Button>
          </Link>
        </div>

        {/* Mobile Menu Toggle - Fixed breakpoint to lg */}
        <button className="lg:hidden p-2 text-gray-600" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-214">
          {isMenuOpen ? <X className="h-6 w-6" data-id="element-215" /> : <Menu className="h-6 w-6" data-id="element-216" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="lg:hidden border-t bg-white p-4 space-y-4 shadow-lg absolute w-full max-h-[calc(100vh-64px)] overflow-y-auto z-50" data-id="element-217">
          <nav className="flex flex-col gap-4" data-id="element-218">
            {navItems.map(item => <Link key={item.path} to={item.path} className={cn('text-sm font-medium py-2 border-b border-gray-100', isActive(item.path) ? 'text-primary-600' : 'text-gray-600')} onClick={() => setIsMenuOpen(false)} data-id="element-219">
                {item.name}
              </Link>)}
            <Link to="/portal" className="text-sm font-medium py-2 border-b border-gray-100 text-gray-600 flex items-center gap-2" onClick={() => setIsMenuOpen(false)} data-id="element-220">
              <Grid className="h-4 w-4" data-id="element-221" />
              Pilih Portal
            </Link>
            <Link to="/lapor-isu" onClick={() => setIsMenuOpen(false)} data-id="element-222">
              <Button className="w-full bg-primary-600 mt-2" data-id="element-223">Lapor Isu</Button>
            </Link>
          </nav>
        </div>}
    </header>;
}